import { Capacitor } from '@capacitor/core';

// Em desenvolvimento usa o proxy local. Em Pages, inclusive nas prévias de
// deploy, e no shell Capacitor, usa o Worker público para que login e chat
// não tentem chamar /api dentro de um cliente estático.
const isAthenaPages = typeof window !== 'undefined'
  && /(^|\.)athena-8ob\.pages\.dev$/i.test(window.location.hostname);
export const IS_NATIVE_APP = Capacitor.isNativePlatform();
export const ATHENA_PLATFORM = IS_NATIVE_APP ? Capacitor.getPlatform() : 'web';

const defaultApi = (isAthenaPages || IS_NATIVE_APP)
  ? 'https://athena-api.emergent558.workers.dev/api'
  : '/api';

export const API_BASE = (process.env.REACT_APP_API_URL || defaultApi).replace(/\/$/, '');
